module.exports = __webpack_public_path__ + "img/windows-brands.191a3337.svg";